var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF8C42",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9666 16.6084C22.6582 16.6084 22.3999 16.3751 22.3666 16.0667C22.1666 14.2334 21.1832 12.5834 19.6666 11.5334C19.3916 11.3417 19.3249 10.9667 19.5166 10.6917C19.7082 10.4167 20.0832 10.3501 20.3582 10.5417C22.1666 11.8001 23.3332 13.7667 23.5749 15.9417C23.6082 16.2751 23.3666 16.5751 23.0332 16.6084C23.0082 16.6084 22.9916 16.6084 22.9666 16.6084Z",
    fill: "#FF8C42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11674 16.65C9.10008 16.65 9.07508 16.65 9.05841 16.65C8.72508 16.6167 8.48341 16.3167 8.51674 15.9834C8.74174 13.8084 9.89174 11.8417 11.6834 10.575C11.9501 10.3834 12.3334 10.45 12.5251 10.7167C12.7167 10.9917 12.6501 11.3667 12.3834 11.5584C10.8834 12.625 9.90841 14.275 9.72508 16.1C9.69174 16.4167 9.42508 16.65 9.11674 16.65Z",
    fill: "#FF8C42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3248 23.5833C18.2998 24.075 17.1998 24.325 16.0498 24.325C14.8498 24.325 13.7082 24.0583 12.6415 23.5167C12.3415 23.375 12.2248 23.0083 12.3748 22.7083C12.5165 22.4083 12.8832 22.2917 13.1832 22.4333C13.7082 22.7 14.2665 22.8833 14.8332 22.9917C15.5998 23.1417 16.3832 23.15 17.1498 23.0167C17.7165 22.9167 18.2748 22.7417 18.7915 22.4917C19.0998 22.35 19.4665 22.4667 19.5998 22.775C19.7498 23.075 19.6332 23.4417 19.3248 23.5833Z",
    fill: "#FF8C42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0414 7.67505C14.7497 7.67505 13.6914 8.72505 13.6914 10.025C13.6914 11.325 14.7414 12.375 16.0414 12.375C17.3414 12.375 18.3914 11.325 18.3914 10.025C18.3914 8.72505 17.3414 7.67505 16.0414 7.67505Z",
    fill: "#FF8C42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2084 17.5583C8.91673 17.5583 7.8584 18.6084 7.8584 19.9083C7.8584 21.2083 8.9084 22.2583 10.2084 22.2583C11.5084 22.2583 12.5584 21.2083 12.5584 19.9083C12.5584 18.6084 11.5001 17.5583 10.2084 17.5583Z",
    fill: "#FF8C42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7914 17.5583C20.4997 17.5583 19.4414 18.6084 19.4414 19.9083C19.4414 21.2083 20.4914 22.2583 21.7914 22.2583C23.0914 22.2583 24.1414 21.2083 24.1414 19.9083C24.1414 18.6084 23.0914 17.5583 21.7914 17.5583Z",
    fill: "#FF8C42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.d222462334ec5d121dbadc64094009c6.svg";
export { ForwardRef as ReactComponent };